<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_238_108)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M24 12C24 18.6274 18.6274 24 12 24C5.37261 24 0 18.6274 0 12C0 5.37257 5.37261 0 12 0C18.6274 0 24 5.37257 24 12ZM10.95 7.2C10.95 6.62011 11.4201 6.15 12 6.15H12.012C12.5919 6.15 13.062 6.62011 13.062 7.2C13.062 7.7799 12.5919 8.25 12.012 8.25H12C11.4201 8.25 10.95 7.7799 10.95 7.2ZM10.8 10.95C10.2201 10.95 9.75 11.4201 9.75 12C9.75 12.5799 10.2201 13.05 10.8 13.05H10.95V16.8C10.95 17.3799 11.4201 17.85 12 17.85H13.2C13.7799 17.85 14.25 17.3799 14.25 16.8C14.25 16.2201 13.7799 15.75 13.2 15.75H13.05V12C13.05 11.4201 12.5799 10.95 12 10.95H10.8Z" fill="#5B6770"/>
</g>
<defs>
<clipPath id="clip0_238_108">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
